// Maps raw API/internal values to user-facing display labels.
// Keys must match exactly what the backend returns — only the label shown in the UI changes.
// Add new entries here when a display label needs to differ from its internal value.
export const DISPLAY_TEXT_MAP: Record<string, string> = {
  Behaviour: "Behavior",
  // Competency band levels (L1–L4)
  L1: "Far",
  L2: "Familiar",
  L3: "Known",
  L4: "Core",
  // Activity maturity levels (M1–M4)
  M1: "Experimenting",
  M2: "Skilled",
  M3: "Competent",
  M4: "Mature",
  // Scoring rule operators — the backend's equality operator is "==" to
  // disambiguate from assignment, but for non-developer authors the
  // single "=" is the recognised mathematical symbol. Internal value
  // stays "==" everywhere (option value, API payload, evaluator switch);
  // only the rendered label changes.
  "==": "=",
};

// Returns the display label for a given internal value, falling back to the original if no mapping exists.
export const toDisplayText = (text: string): string => DISPLAY_TEXT_MAP[text] ?? text;
